import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import { Link } from "react-router-dom";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";
import CookieManager from "../../services/CookieManager";
import { ReactComponent as Close } from "../../assets/BlackButtonRoundMinusSmall.svg";
import MewoService from "../../services/mewoService";
import Constants from "../../services/constants";

const defaultMessage = "Search by clicking on a keyword";

const SoundFx = (props) => {
  const soundFXFilterTags = ["Ambience", "Assembly Line", "Atmosphere", "Beds", "Blips", "Bombs", "Booms", "Braams", "Bridges",
    "Builds", "Bumper", "Bursts", "Claps", "Designers", "Drones", "Effect", "Elements", "Endings", "Foley",
    "FX", "Guns", "Hits", "Impact", "Intros", "Jingles", "Layers", "Logo", "Loop", "Pings", "Pulses", "Riff", "Rise",
    "Rumble", "Signature", "Slams", "Soundscapes", "Stabs", "Sting", "Stomps", "Strikes", "Suck Backs",
    "Swells", "Textures", "Tool", "Transitions", "Whooshes"];

  const ref = useRef(null);
  const [selectedTag, setSelectedTag] = useState(CookieManager.getCookie("selected-soundfx-tag") || "");
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [allDataLoaded, setAllDataLoaded] = useState(true);
  const [loadMore, setLoadMore] = useState(false);
  const [soundFXList, setSoundFXList] = useState([]);
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);

  useEffect(() => {
    if (selectedTag?.length > 0) {
      (async () => {
        await loadSoundFXData(selectedTag)
      })()
    }
  }, [selectedTag])

  useEffect(() => {
    if (loadMore)
      (async () => {
        await loadSoundFXData(selectedTag)
      })()
  }, [loadMore])

  const onTagSelect = (elem) => {
    if (loading) return;

    if (selectedTag != elem) {
      CookieManager.setCookie("selected-soundfx-tag", elem)
      setSelectedTag(elem);
    } else {
      CookieManager.setCookie("selected-soundfx-tag", "")
      setSelectedTag("");
    }
    setPageNo(0);
    setAllDataLoaded(true);
    setSoundFXList([]);
    setIsFilterDropdownOpen(false);
  }

  const onTagRemove = () => {
    CookieManager.setCookie("selected-soundfx-tag", "")
    setPageNo(0);
    setAllDataLoaded(true);
    setSoundFXList([]);
    setSelectedTag("");
    setIsFilterDropdownOpen(false);
  }

  const loadSoundFXData = async (query = "") => {
    setLoading(true);
    let reqObj = {
      url: `public/search/panel`,
      method: 'post',
      data: JSON.stringify({
        query,
        albums: { page: pageNo, max: Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE, search_descriptions: false },
      }),
    };
    await MewoService.loadMewoData(reqObj).then((resp) => {
      let tempDataList = [...soundFXList];
      if (resp?.albums?.hits?.length > 0)
        tempDataList.push(...resp?.albums?.hits)

      if (resp?.albums?.hits?.length > 0 && tempDataList?.length < resp?.albums?.total?.value) {
        setAllDataLoaded(false);
        setPageNo(pageNo + 1);
      } else
        setAllDataLoaded(true);

      setSoundFXList(tempDataList);
    }).catch((err) => {
      console.log("SoundFX Data Loading Error : ", err);
      Helper.handleError(err);
    });
    setLoadMore(false)
    setLoading(false);
  }

  useEffect(() => {
    if (ref.current !== null) {
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      };
      let observer = new IntersectionObserver(loadMoreData, options);
      let target = document.querySelector("#load-more-data");
      observer.observe(target);
    }
  });

  const loadMoreData = async (entries, observer) => {
    entries.map(async (entry) => {
      if (entry.isIntersecting) {
        if (!allDataLoaded) {
          setLoadMore(true);
        }
      }
    });
  };

  return (
    <div className="lg:px-8 items-center flex-1 pt-20 lg:pt-3 sm:mx-8 mx-8 lg:mx-20 playlist">
      {/* Mobile Responsive Filter */}
      <div className="block sm:hidden mb-4 relative">
        <div
          className="w-full bg-gray-200 p-3 rounded-lg flex justify-between items-center cursor-pointer"
          onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
        >
          <span>{selectedTag || "Select Filter"}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 transform transition-transform ${isFilterDropdownOpen ? 'rotate-180' : ''}`}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>

        {isFilterDropdownOpen && (
          <div className="absolute z-10 w-full bg-white shadow-lg rounded-lg mt-2 max-h-60 overflow-y-auto">
            {soundFXFilterTags.map((elem, index) => (
              <div
                key={index}
                className={`
            p-3 cursor-pointer 
            ${selectedTag === elem ? 'bg-symbgGray text-dark' : 'hover:bg-gray-100'}
            flex justify-between items-center
          `}
                onClick={() => onTagSelect(elem)}
              >
                <span className="text-left flex-grow">{elem}</span>
                {selectedTag === elem && (
                  <Close
                    onClick={(e) => {
                      e.stopPropagation();
                      onTagRemove();
                    }}
                    className="w-4 h-4 ml-2"
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Existing Desktop Filter */}
      <div className="flex w-full flex-wrap hidden lg:flex">
        {soundFXFilterTags?.map((elem, index) => (
          <div
            key={index}
            className={`flex px-2 py-1 mx-1 my-1 text-xs syncbutton cursor-pointer rounded-full ${selectedTag == elem
              ? " px-4 bg-symbgGray "
              : "px-4  syncbuttongrey hover:bg-symbgGray hover:scale-75"
              }`}
            onClick={() => { onTagSelect(elem) }}
          >
            {elem}
            {elem === selectedTag &&
              <Close onClick={(e) => {
                e.stopPropagation();
                onTagRemove()
              }}
                className="filterclose mx-3"
              />
            }
          </div>
        ))}
      </div>

      <div className="border-t my-2"></div>
      <div className="w-full">
        {loading &&
          <div className='w-full'>
            <BouncingLoader />
          </div>
        }
        {!(selectedTag?.length > 0) &&
          <div className="text-xl text-center text-green-500 my-5">
            {defaultMessage}
          </div>
        }
        {!loading && selectedTag?.length > 0 && !(soundFXList?.length > 0) ? (
          <div className="text-xl text-center text-red-500 my-5">
            No Data Found
          </div>
        ) :
          (<div className="bg-white grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {soundFXList?.map((elem, index) => (
              <div
                key={elem?.id}
                className="mb-4 sm:mb-6 animate-fadeIn"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <Link to={`/album/${elem?.id}`} className="block">
                  {/* Image Section */}
                  <div className="image-container relative mb-3 sm:mb-4 transform transition-transform duration-300 hover:scale-105">
                    {elem != null && elem?.image != null ? (
                      <img
                        src={elem?.image?.large?.url || defaultImage}
                        alt="Album img"
                        className="w-full aspect-square object-cover rounded-2xl shadow-md"
                      />
                    ) : (
                      <img
                        src={defaultImage}
                        alt="Album img"
                        className="w-full aspect-square object-cover rounded-2xl shadow-md"
                      />
                    )}
                    <span
                      className="play_icon absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity"
                      title="Play"
                    ></span>
                  </div>

                  {/* Text Section */}
                  <div className="text-content px-2">
                    <p className="text-sm font-bold truncate mb-1">
                      {elem?.title}
                    </p>

                    {elem.descriptions?.length > 0 && (
                      <p
                        className="text-xs text-gray-600 truncate"
                        title={elem.descriptions[0]?.value}
                      >
                        {elem.descriptions[0]?.value || elem?.title}
                      </p>
                    )}
                  </div>
                </Link>
              </div>
            ))}
          </div>)
        }
        {!allDataLoaded && (
          <div id="load-more-data" ref={ref} className="p-2">
            <BouncingLoader />
          </div>
        )}
      </div>
    </div>
  );
};

export default SoundFx;